
import React, { Component } from "react";

export class PqrAdmin extends Component {

    constructor(props) {
        super(props);

        this.state = {
            model: []
        }
    }

    componentDidMount() {
        this.get();
    }

    async get() {
       
        const request = {
            method: 'Get',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `bearer ${localStorage.getItem('token')}`
            }
        }

        this.setState({ loading: true });
        let response = await fetch(`PQR/Get`, request);
        this.setState({ loading: false })

        switch (response.status) {
            case 200:
                const data = await response.json();
                this.setState({ model: data})
                break;
            default:
                alert(`La información no se proceso con éxito, verifique los datos e inténtelo de nuevo.`);
        }
        
    }

    render() {
        return (
            <div className="resultProcess mt-3">

                <h2 className="text-center mt-5">PQR's registradas en el sistema</h2>

                <div className="row head mt-5">
                    <div className="col-lg-1 border p-3">Id</div>
                    <div className="col-lg-2 border p-3">Tipo</div>
                    <div className="col-lg-2 border p-3">Nombre</div>
                    <div className="col-lg-2 border p-3">Email</div>
                    <div className="col-lg-2 border p-3">Celular</div>
                    <div className="col-lg-3 border p-3">Mensaje</div>
                </div>

                {this.state.model ? this.state.model.map((item) => <div className="row">
                    <div className="col-lg-1 border p-3">{item.id}</div>
                    <div className="col-lg-2 border p-3">{item.type}</div>
                    <div className="col-lg-2 border p-3">{item.name}</div>
                    <div className="col-lg-2 border p-3">{item.email}</div>
                    <div className="col-lg-2 border p-3">{item.cell}</div>
                    <div className="col-lg-3 border p-3">{item.message}</div>
                   
                </div>) : "Sin datos."}

            </div>
        )
    }
}